<template>
    <div class="c-offcanvas-menu-wrap">
        <div class="c-right-empty-space-listener" v-on:click="closeOffcanvas()"></div>
        <div class="c-has-header">
          <div title="Club London" class="c-offcanvas-logo-wrap">
            <img src="@/assets/img/london-logo-title-white.svg" alt="Club London" />
          </div>   
          <button class="c-btn c-close-btn" v-on:click="closeOffcanvas()"><i class="fa fa-times" aria-hidden="true"></i></button>
        </div>
        <ul class="c-offcanvas-nav-list">
          <!-- FutureEvents -->
          <li v-bind:class="{'c-active': currentViewName == 'FutureEvents'}" v-on:click="goToView('future-events')"><a><i class="fa fa-calendar" aria-hidden="true"></i>Događaji</a></li>
          <!-- EventsArchive -->
          <li v-if="glMixin_userAccessCheck(inputFirebaseUser, 'h')" 
          v-bind:class="{'c-active': currentViewName == 'EventsArchive'}" v-on:click="goToView('events-archive')"><a><i class="fa fa-archive" aria-hidden="true"></i>Arhiva događaja</a></li>
          <!-- RegularGuests -->
          <li v-if="glMixin_userAccessCheck(inputFirebaseUser, 'm')"
          v-bind:class="{'c-active': currentViewName == 'RegularGuests'}" v-on:click="goToView('regular-guests')"><a><i class="fa fa-address-book" aria-hidden="true"></i>Stalni gosti</a></li>
          <!-- WaitersList -->
          <li v-if="glMixin_userAccessCheck(inputFirebaseUser, 'h')"
          v-bind:class="{'c-active': currentViewName == 'WaitersList'}" v-on:click="goToView('waiters-list')"><a><i class="fa fa-get-pocket" aria-hidden="true"></i>Konobari</a></li>
          <!-- VenuesList -->
          <li v-if="glMixin_userAccessCheck(inputFirebaseUser, 9)"
          v-bind:class="{'c-active': currentViewName == 'VenuesList'}" v-on:click="goToView('venues-list')"><a><i class="fa fa-dot-circle-o" aria-hidden="true"></i>Tipovi rezervacija</a></li>
          <!-- AdminsList -->
          <li v-if="glMixin_userAccessCheck(inputFirebaseUser, 10)"
          v-bind:class="{'c-active': currentViewName == 'AdminsList'}" v-on:click="goToView('admins-list')"><a><i class="fa fa-user-circle" aria-hidden="true"></i>Administratori</a></li>
          <!-- Admin Account Info -->
          <li v-on:click="openWhoAmIDetails()"><a><i class="fa fa-info-circle" aria-hidden="true"></i>Moje informacije</a></li>
          <!-- LogsHistory -->
          <!-- <li v-bind:class="{'c-active': currentViewName == 'LogsHistory'}" v-on:click="goToView('logs-history')"><a><i class="fa fa-history" aria-hidden="true"></i>Istorija izmena</a></li> -->
          <!-- Refresh page -->
          <li v-on:click="refreshPage()"><a><i class="fa fa-refresh" aria-hidden="true"></i>Osvezi aplikaciju</a></li>
          <!-- Login -->
          <li v-on:click="goToView('logout')"><a><i class="fa fa-power-off" aria-hidden="true"></i>Odjavi se</a></li>
        </ul>
        <div style="padding:10px;"><small style="font-size:11px;">Verzija 2021/6.1</small></div>
        <!-- <div v-if="inputFirebaseUser && inputFirebaseUser.currentUser && inputFirebaseUser.userDetails" style="font-size:11px;">
          <div v-if="inputFirebaseUser.currentUser.uid">uid: {{inputFirebaseUser.currentUser.uid}}</div>
          <div v-if="inputFirebaseUser.currentUser.email">email: {{inputFirebaseUser.currentUser.email}}</div>
          <div v-if="inputFirebaseUser.userDetails.enterPass">enterPass: {{inputFirebaseUser.userDetails.enterPass}}</div>
          <div v-if="inputFirebaseUser.userDetails.firstName">firstName: {{inputFirebaseUser.userDetails.firstName}}</div>
          <div v-if="inputFirebaseUser.userDetails.lastName">lastName: {{inputFirebaseUser.userDetails.lastName}}</div>
          <div v-if="inputFirebaseUser.userDetails.nickName">nickName: {{inputFirebaseUser.userDetails.nickName}}</div>
          <div v-if="inputFirebaseUser.isOnline">isOnline: {{inputFirebaseUser.isOnline}}</div>
        </div> -->
      <!-- Modal Templates -->
      <transition name="slide-up" mode="out-in">
        <component 
          v-if="modalComponent.isVisible" 
          v-bind:is="modalComponent.activeModalComponent"
          v-bind:input-modal-data = "modalComponent.dataForModal"
        ></component>
      </transition>        
    </div>
</template>

<script>
import EventBus from '@/EventBus'
import Firebase from 'firebase'
import ModalWhoAmI from '@/components/adminsList/ModalWhoAmI'

// import router from '@/router/index'
export default {
  name: 'OffcanvasNav',
  props: ['inputFirebaseUser'],
  //mixins: [glMethod_userAccessCheck],
  components: {
    ModalWhoAmI: ModalWhoAmI
  },  
  //router: router,
  data () {
    return {
      currentViewName: null,
      // ~ for showing modal
      modalComponent: {
        isVisible: false,
        activeModalComponent: null,
        dataForModal: null
      }      
    }
  },
  methods: {
    closeOffcanvas: function () {
      // ~ hide offcanvas component inside 'MainApp' component      
      EventBus.$emit('closeToggleOffcanvas');
    },
    goToView: function (inputNewRoutePath){
      // Close Offcanvas menu
      EventBus.$emit('closeToggleOffcanvas');
      // Check if user wants to logout or to move to next view
      if (inputNewRoutePath == 'logout'){        
        Firebase.auth().signOut().then(() => {
          this.$router.replace('login')
        })
      }else{
        this.$router.replace(inputNewRoutePath);
      }
    },
    refreshPage: function () {
      location.reload(true);
    },
    // ~ when user wants to change Reservations for some event
    openWhoAmIDetails: function () {
      // ~ then we need to show different page with wanted event
      if (this.inputFirebaseUser && this.inputFirebaseUser.currentUser && this.inputFirebaseUser.userDetails){
        var promiseFromModal = this.openModal_WhoAmIDetails(this.inputFirebaseUser).then(
          function(response){
            //console.log('Modal returned response: ' + JSON.stringify(response, null, 2) );
            // ~ close modal
            this.closeModal();
            this.closeOffcanvas();
          }.bind(this),
          function(reject){
            console.log('Modal returned reject');
            // ~ close modal
            this.closeModal();
            this.closeOffcanvas();
          }.bind(this)
        );
      }
    },
    openModal_WhoAmIDetails: function (inputFirebaseUser) {
      return new Promise ((resolve, reject)=>{
        this.modalComponent.activeModalComponent = ModalWhoAmI;
        this.modalComponent.isVisible = true;
        this.modalComponent.dataForModal = {
            headerTitle: 'Admin Who Am I',
            dataForModal: inputFirebaseUser,
            resolve: resolve,
            reject: reject
        }
      });
    },    
    /* #endregion Regular Guest Details Modal */    
    closeModal: function (){
      this.modalComponent.isVisible = false;
      this.modalComponent.activeModalComponent = null;
      this.modalComponent.dataForModal = null;
    }       
  },
  created () {
    //console.log('references: ' + this.$refs);
    //console.log('this.$parent: ' + JSON.stringify(this.$parent, null, 2));
    /* #region Router Changer functions */
    this.$router.onReady(function () {
      if (this.$route.name) {
        this.currentViewName = this.$route.name
      }
    }.bind(this))
    /* #endregion Router Changer functions */
  }  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style></style>



// WEBPACK FOOTER //
// src/components/offcanvas/OffcanvasNav.vue